import hasFeature from "src/js/stores/user/actions/hasFeature";
import Feature from "src/js/stores/user/Feature";
import { HOMETRACK_ADDON, LANDFUND_ADDON, GIVE_MY_VIEW_ADDON } from "./constants";
import { HOMETRACK_ADDON_ROUTE, LANDFUND_ADDON_ROUTE, GIVE_MY_VIEW_ADDON_ROUTE } from "../constants";
import { AddOnPromotionCard } from "./components/AddOnPromotionCard";
import {
  hometrackPrimaryActionHandler,
  giveMyViewPrimaryActionHandler,
  landFundPrimaryActionHandler,
} from "./addOnActionHandlers";

export function AddOnsStoreLandingPage() {
  const hasZooplaAddon = hasFeature(Feature.zooplaFullAccess);

  return (
    <div className="flex flex-col gap-y-6">
      <div className="flex flex-col gap-y-3">
        <h1 className="text-sm font-medium text-text-base-secondary">General</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <AddOnPromotionCard
            {...HOMETRACK_ADDON}
            onPrimaryActionClick={hometrackPrimaryActionHandler}
            primaryActionText={hasZooplaAddon ? "Added" : "Contact"}
            primaryActionDisabled={hasZooplaAddon}
            linkTo={HOMETRACK_ADDON_ROUTE}
          />
        </div>
      </div>
      <div className="flex flex-col gap-y-3">
        <h1 className="text-sm font-medium text-text-base-secondary">Other</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <AddOnPromotionCard
            {...LANDFUND_ADDON}
            onPrimaryActionClick={landFundPrimaryActionHandler}
            primaryActionText="View"
            linkTo={LANDFUND_ADDON_ROUTE}
          />
          <AddOnPromotionCard
            {...GIVE_MY_VIEW_ADDON}
            onPrimaryActionClick={giveMyViewPrimaryActionHandler}
            primaryActionText="View"
            linkTo={GIVE_MY_VIEW_ADDON_ROUTE}
          />
        </div>
      </div>
    </div>
  );
}
